export enum SplOriginAlias {
  api = 'api',
  client = 'client',
  portal = 'portal',
  workspace = 'workspace',
}
